import { useRef, useState, useEffect } from "react";
import styles from "./index.module.scss";
import { useServices } from "@/services-context";
import ChristmasBannerEn from "@/assets/holiday-banners/holliday-2026-en-1.webp";
import ChristmasBannerEnMob from "@/assets/holiday-banners/holliday-2026-en-mob-1.webp";
import ChristmasBannerDe from "@/assets/holiday-banners/holliday-2026-de.webp";
import ChristmasBannerDeMob from "@/assets/holiday-banners/holliday-2026-de-mob.webp";
import ChristmasBannerEs from "@/assets/holiday-banners/holliday-2026-es.webp";
import ChristmasBannerEsMob from "@/assets/holiday-banners/holliday-2026-es-mob.webp";
import ChristmasBannerFr from "@/assets/holiday-banners/holliday-2026-fr-1.webp";
import ChristmasBannerFrMob from "@/assets/holiday-banners/holliday-2026-fr-mob-1.webp";
import ChristmasBannerKo from "@/assets/holiday-banners/holliday-2026-ko.webp";
import ChristmasBannerKoMob from "@/assets/holiday-banners/holliday-2026-ko-mob.webp";
import ChristmasBannerLv from "@/assets/holiday-banners/holliday-2026-lv.webp";
import ChristmasBannerLvMob from "@/assets/holiday-banners/holliday-2026-lv-mob.webp";
import ChristmasBannerPl from "@/assets/holiday-banners/holliday-2026-pl.webp";
import ChristmasBannerPlMob from "@/assets/holiday-banners/holliday-2026-pl-mob.webp";
import ChristmasBannerRu from "@/assets/holiday-banners/holliday-2026-ru.webp";
import ChristmasBannerRuMob from "@/assets/holiday-banners/holliday-2026-ru-mob.webp";
import ChristmasBannerZh from "@/assets/holiday-banners/holliday-2026-zh.webp";
import ChristmasBannerZhMob from "@/assets/holiday-banners/holliday-2026-zh-mob.webp";
import { NY_HOLIDAY_CODE } from "@/services/holidays";
import classNames from "classnames";
import { LayoutTypes, useLayoutType } from "@/util-react/layout.tsx";

const banners = {
  en: { desktop: ChristmasBannerEn, mob: ChristmasBannerEnMob },
  de: { desktop: ChristmasBannerDe, mob: ChristmasBannerDeMob },
  es: { desktop: ChristmasBannerEs, mob: ChristmasBannerEsMob },
  fr: { desktop: ChristmasBannerFr, mob: ChristmasBannerFrMob },
  ko: { desktop: ChristmasBannerKo, mob: ChristmasBannerKoMob },
  lv: { desktop: ChristmasBannerLv, mob: ChristmasBannerLvMob },
  pl: { desktop: ChristmasBannerPl, mob: ChristmasBannerPlMob },
  ru: { desktop: ChristmasBannerRu, mob: ChristmasBannerRuMob },
  zh: { desktop: ChristmasBannerZh, mob: ChristmasBannerZhMob },
};

const LOCAL_STORAGE_NAME = "bc_holidayEvents";

function NyBanner() {
  const { holidays, parameters } = useServices();

  const [isVisible, setIsVisible] = useState(false);
  const isBannerTime = holidays?.getNy() !== undefined;

  const { layoutType, defaultLayoutStyleType } = useLayoutType();

  const holidayEventsLocalStorage = (() => {
    const localStorage = window.localStorage.getItem(LOCAL_STORAGE_NAME) && JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_NAME) as string);

    if (Array.isArray(localStorage) && localStorage.length > 0) {
      return localStorage;
    }

    return null;
  })();

  const isAlreadyShow = () => {
    if (holidayEventsLocalStorage !== null) {
      return holidayEventsLocalStorage.some((event) => event.code === NY_HOLIDAY_CODE);
    }

    return false;
  };

  useEffect(() => {
    setIsVisible(!isAlreadyShow() && isBannerTime);
  }, [isBannerTime]);

  const handleCloseBanner = () => {
    setIsVisible(false);

    const nyEventFromApi = holidays?.getNy();
    if (holidayEventsLocalStorage !== null && nyEventFromApi) {
      window.localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify([...holidayEventsLocalStorage, nyEventFromApi]));
    } else {
      window.localStorage.setItem(LOCAL_STORAGE_NAME, JSON.stringify([nyEventFromApi]));
    }
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleCloseBanner();
    }
  };

  if (!isVisible) return null;

  const currentLang = () => {
    return parameters?.parameters?.language || "en";
  };

  const getBannerSrc = () => {
    const currentLangCode = currentLang().split("-")[0];

    return layoutType === LayoutTypes.TYPE_MOBILE ? banners[currentLangCode]?.mob : banners[currentLangCode]?.desktop;
  };

  return (
    <div className={classNames(styles.overlay, styles[defaultLayoutStyleType])} onClick={handleOverlayClick}>
      <div className={classNames(styles.bannerContainer)}>
        <button className={classNames(styles.closeButton)} onClick={handleCloseBanner}>
          ×
        </button>
        <img src={getBannerSrc()} alt="Banner" className={classNames(styles.bannerImage)} />
      </div>
    </div>
  );
}

export default NyBanner;
